import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';

const Context = /*#__PURE__*/createContext(void 0);
const Provider = Context.Provider;

var useDropdownRouter = (() => useContext(Context));

const DropdownRoute = props => {
  const router = useDropdownRouter();
  const canRender = useMemo(() => {
    if (router.state.path == null) {
      return false;
    }

    if (router.state.path === props.path) {
      return true;
    }

    return false;
  }, [props.path, router.state.path]);

  if (!canRender) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};

const DropdownRouter = props => {
  const [path, setPath] = useState(null);
  const state = useMemo(() => ({
    path
  }), [path]);
  const actions = useMemo(() => ({
    setPath
  }), [setPath]);
  const value = useMemo(() => ({
    state,
    actions
  }), [state, actions]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, props.children);
};

var useCloseDropdown = (() => {
  const router = useDropdownRouter();
  return useCallback(() => {
    router.actions.setPath(null);
  }, [router.actions.setPath]);
});

var useIsOpen = (path => {
  const router = useDropdownRouter();
  return path === router.state.path;
});

var useOpenDropdown = (path => {
  const router = useDropdownRouter();
  return useCallback(() => {
    router.actions.setPath(path);
  }, [path, router.actions.setPath]);
});

var useToggleDropdown = (path => {
  const router = useDropdownRouter();
  return useCallback(() => {
    if (router.state.path === path) {
      router.actions.setPath(void 0);
    } else {
      router.actions.setPath(path);
    }
  }, [router.state.path, router.actions.setPath, path]);
});

export { DropdownRoute, DropdownRouter, useCloseDropdown, useDropdownRouter, useIsOpen, useOpenDropdown, useToggleDropdown };
